/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
/* eslint-disable no-undef */
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'

import {
  CallToUsButtonComponent,
  LanguageSwitcherComponent,
  Logo,
  Nav,
} from '../../components'
import LinkComponent from '../../components/LinkComponent/LinkComponent'
import SideBarItem from '../../components/SideBarItem/SideBarItem'
import { useFooterData } from '../../hooks/useFooterData'
import { useHeaderData } from '../../hooks/useHeaderData'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useTreatmentCategories } from '../../hooks/useTreatmentCategories'
import { defaultLanguage } from '../../utils/appConfig'
import { ContentParser } from '../../utils/helpers'
import MapModal from '../MapModal/MapModal'
import {
  bacgroundImage,
  backdrop,
  backdropOpen,
  categoryLinks,
  fontSizeFix,
  gridIamge,
  gridposition,
  habmurgerLabel,
  hamburgerButton,
  headerContainer,
  headerContentContainter,
  itemsAligment,
  languageSelectiorScrolled,
  locationMap,
  mapIcon,
  mobileContainer,
  mobileContentContainer,
  mobileMenu,
  mobileMenuFooter,
  mobileMenuFooterContent,
  mobileMenuHeader,
  mobileMenuOpen,
  mobileOpenedLogoContainer,
  navContentContainer,
  navStyling,
  openedContainer,
  openedLogoContainer,
  scrolledContainer,
  scrolledHeaderContentContainer,
  scrolledLogoContainer,
  scrolledNavContentContainer,
} from './HeaderSection.module.css'

const HeaderSection = ({ pageContext }) => {
  const { altLanguages, lang: currentLang } = pageContext
  const data = useHeaderData().filter(
    (item) => item.language.slug === currentLang.slice(0, 2),
  )
  const footerData = useFooterData().filter(
    (item) => item.language.slug === currentLang.slice(0, 2),
  )
  const [scrolled, setScrolled] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [opened, setOpened] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [clickedItem, setClickedItem] = useState('')
  const {
    contenttypes: {
      footer: { generallinkslabel },
      header: { cta, cta2, staticlinks, treatments },
    },
  } = data[0]
  const {
    contenttypes: {
      footer: {
        addresslabel,
        addresstext,
        emailaddress,
        emaillabel,
        footermaincategories,
      },
    },
  } = footerData[0]
  const treatmentsLinks = ContentParser(treatments, 'treatment')
  const staticItemLinks = ContentParser(staticlinks, 'link')
  const treatmentsAltData = useTreatmentCategories().filter(
    (item) => item.language.slug === currentLang.slice(0, 2),
  )
  const { treatmentcategorycontent } = treatmentsAltData[0]
  const treatmentAltCategories = ContentParser(
    treatmentcategorycontent,
    'treatmentcategory',
  ).filter((res) => res.treatments !== null)
  const subAltCategories = treatmentAltCategories.filter(
    (res) => res.isundercategory !== null,
  )
  const mainAltCategories = treatmentAltCategories.filter(
    (res) => res.isundercategory === null,
  )

  const [activeTreatment, setActiveTreatment] = useState(
    treatmentsLinks.length > 0 ? JSON.parse(treatmentsLinks[0]).title : 'None',
  )
  const [mobileMenuOpened, setMobileMenuOpened] = useState(false)

  const isDesktop = useMediaQuery('(min-width: 1200px)')
  let ctaContent = cta
  if (typeof cta === 'string') {
    ctaContent = JSON.parse(cta)
  }
  let cta2Content = cta2
  if (typeof cta2 === 'string') {
    cta2Content = JSON.parse(cta2)
  }

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    })
    return () =>
      window.removeEventListener('scroll', () => {
        if (window.scrollY > 40) {
          setScrolled(true)
        } else {
          setScrolled(false)
        }
      })
  }, [])

  useEffect(() => {
    if (!mobileMenuOpened) {
      if (typeof window !== 'undefined') {
        if (typeof document !== 'undefined') {
          document.body.style.overflowY = 'unset'
        }
      }
    }
  }, [mobileMenuOpened])

  useEffect(() => {
    if (!modalOpen) {
      document.body.style.overflowY = 'unset'
    }
  }, [modalOpen])

  const handleCategoryClick = (category) => {
    if (category !== activeTreatment) {
      setActiveTreatment(category)
    }
  }

  const handleMobileMenuClick = () => {
    if (isSidebarOpen) {
      setClickedItem('')
      setIsSidebarOpen(false)
    } else {
      setMobileMenuOpened(!mobileMenuOpened)
      if (!mobileMenuOpened) {
        document.body.style.overflowY = 'hidden'
      } else {
        document.body.style.overflowY = 'unset'
      }
    }
  }

  const handleModal = () => {
    if (!modalOpen) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.style.overflowY = 'unset'
    }
    setModalOpen(!modalOpen)
  }
  const accordions = treatmentsLinks
    .map((e) => JSON.parse(e))
    .slice(1)
    .concat(footermaincategories)
    .map((category, index) => {
      let newData = []

      if (typeof category === 'string') {
        newData =
          subAltCategories.filter((item) => item.heading === category)[0]
            ?.treatments.nodes || []
      } else {
        newData =
          mainAltCategories.filter((item) => item.heading === category.title)[0]
            ?.treatments.nodes || []
      }
      if (newData.length === 0) {
        return null
      }

      const accordionData = newData?.map((treatment, treatmentIndex) => {
        const categoryName = treatment.pageType.name || treatment.title
        const link =
          defaultLanguage === currentLang
            ? `/${treatment.pageType.uri}/`
            : `/${currentLang.slice(0, 2)}/${treatment.pageType.uri}/`
        return (
          <div key={treatmentIndex}>
            <LinkComponent className={categoryLinks} src={link}>
              {categoryName}
            </LinkComponent>
          </div>
        )
      })
      const title = category.title || category
      return { index, title, items: accordionData }
    })

  const staticLinksAccordion = {
    index: accordions.filter((item) => item !== null).length,
    title: generallinkslabel,
    items: staticItemLinks.map((item, itemIndex) => {
      const name = item.nodes[0].pageType.name || item.nodes[0].title
      const link =
        defaultLanguage === currentLang
          ? `/${item.nodes[0].pageType.uri}/`
          : `/${currentLang.slice(0, 2)}/${item.nodes[0].pageType.uri}/`

      return (
        <div key={itemIndex}>
          <LinkComponent className={categoryLinks} src={link}>
            {name}
          </LinkComponent>
        </div>
      )
    }),
  }

  accordions.push(staticLinksAccordion)

  let link = '/'
  if (defaultLanguage !== currentLang) {
    link = `/${currentLang.slice(0, 2)}/`
  }
  const mobileWhatsapp = {
    title: 'WHATSAPP',
  }
  const handleWhatsAppClick = () => {
    Futy.activate('whatsapp', true)
  }
  return (
    <>
      <div
        className={`${headerContainer} ${scrolled ? scrolledContainer : ''}`}
        onMouseLeave={() => setOpened(false)}
        role="presentation"
      >
        <div
          className={`${headerContentContainter} ${
            scrolled ? scrolledHeaderContentContainer : ''
          }`}
          onClick={() => setOpened(false)}
          role="presentation"
        >
          <LinkComponent src={link} type="internal">
            <Logo
              extraClassName={`${
                scrolled || !isDesktop ? scrolledLogoContainer : ''
              } ${mobileMenuOpened ? mobileOpenedLogoContainer : ''}`}
            />
          </LinkComponent>
          <div
            className={`${navContentContainer} ${
              scrolled ? scrolledNavContentContainer : ''
            }`}
          >
            <Nav
              activeTreatment={activeTreatment}
              additionalClassName={`${fontSizeFix} ${
                opened || scrolled ? openedContainer : ''
              }`}
              changed={opened || scrolled}
              currentLang={currentLang.slice(0, 2)}
              defaultLang={defaultLanguage === currentLang}
              footerSection={false}
              generallinkslabel={generallinkslabel}
              mainCategories={mainAltCategories}
              onClick={handleCategoryClick}
              onMouseOver={setOpened}
              opened={opened}
              staticItemLinks={staticItemLinks.map((item) => item.nodes[0])}
              subCategories={subAltCategories}
              treatmentsLinks={treatmentsLinks}
            />
            <LanguageSwitcherComponent
              altLanguages={altLanguages}
              currentLang={currentLang}
              extraClassName={
                scrolled || opened ? languageSelectiorScrolled : ''
              }
            />
            <div
              className={locationMap}
              onClick={handleModal}
              onKeyUp={handleModal}
              role="button"
              tabIndex="0"
            >
              {scrolled || opened ? (
                <StaticImage
                  alt=""
                  className={mapIcon}
                  onClick={handleModal}
                  src="../../assets/icons/mapPin.svg"
                />
              ) : (
                <StaticImage
                  alt=""
                  className={mapIcon}
                  onClick={handleModal}
                  src="../../assets/icons/mapPin-white.svg"
                />
              )}
            </div>
            {cta && <CallToUsButtonComponent cta={ctaContent} desktop />}
          </div>
        </div>
        <div
          className={`${backdrop} ${opened ? backdropOpen : ''}`}
          role="presentation"
        />
      </div>
      <div
        className={`${hamburgerButton} ${scrolled ? openedLogoContainer : ''}`}
      >
        <label className={habmurgerLabel} htmlFor="check">
          <input
            aria-label="Toggle mobile menu"
            checked={mobileMenuOpened}
            id="check"
            onChange={handleMobileMenuClick}
            type="checkbox"
          />
          <span />
          <span />
          <span />
        </label>
      </div>
      <div
        className={`${mobileMenu} ${mobileMenuOpened ? mobileMenuOpen : ''}`}
      >
        <div className={mobileMenuHeader}>
          <LanguageSwitcherComponent
            altLanguages={altLanguages}
            currentLang={currentLang}
            extraClassName={`${gridposition} ${languageSelectiorScrolled}`}
          />
          <Logo extraClassName={`${gridposition} ${gridIamge}`} />
        </div>
        <div className={`${mobileContentContainer}`}>
          <ul className={mobileContainer}>
            {accordions
              .filter((res) => res !== null)
              .map((category, index) => (
                <SideBarItem
                  key={index}
                  clickedItem={clickedItem}
                  extraContentClassname={navStyling}
                  extraTitleClassname={navStyling}
                  innerBtnClassName={itemsAligment}
                  isSidebarOpen={isSidebarOpen}
                  item={category}
                  setClickedItem={setClickedItem}
                  setIsSidebarOpen={setIsSidebarOpen}
                />
              ))}
          </ul>
          <div className={mobileMenuFooter}>
            <div className={mobileMenuFooterContent}>
              {/* {cta && (
                <CallToUsButtonComponent cta={ctaContent} fullHeight mobile />
              )} */}
              {cta && (
                <CallToUsButtonComponent cta={cta2Content} fullHeight orange />
              )}
              {cta && (
                <CallToUsButtonComponent
                  cta={mobileWhatsapp}
                  fullHeight
                  mobile
                  onClick={handleWhatsAppClick}
                />
              )}
            </div>
          </div>
        </div>
        <StaticImage
          alt="background"
          className={bacgroundImage}
          quality={100}
          src="../../assets/images/newMobileMenu.webp"
        />
      </div>
      {isDesktop && (
        <MapModal
          contactData={ctaContent}
          isOpen={modalOpen}
          locationData={{ addresslabel, addresstext, emailaddress, emaillabel }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  )
}

export default HeaderSection
